import { ROBOTIQ_MODBUS_TARGET_ADDRESS } from '../shared/robotiqRegisters';

// Alias of the shared Robotiq Modbus target address, kept to avoid touching
// existing call sites.
export const ROBOTIQ_EPICK_MODBUS_ADDRESS = ROBOTIQ_MODBUS_TARGET_ADDRESS;

export const ACTION_BYTE_INDEX = 0;
export const MOD_BYTE_INDEX = 0; // Same as ACTION, bits 1-2
export const GRIP_TIMEOUT_BYTE_INDEX = 4; // rSP
export const PRESSURE_REQUEST_BYTE_INDEX = 3; // rPR
export const MIN_PRESSURE_REQUEST_BYTE_INDEX = 5; // rFR

export const R_ACT = 0x01;
export const R_GTO = 0x08;
export const R_ATR = 0x04;

export const MOD_AUTO = 0x00;
export const MOD_ADVANCED = 0x01;
export const MOD_MASK = 0x06; // Bits 1 and 2

export const ROBOTIQ_EPICK_TCP_Z_OFFSET = 0.145;
export const ROBOTIQ_EPICK_MASS_KG = 0.741;

export const ROBOTIQ_EPICK_DEFAULT_COLLISION_BOX = {
  origin: { x: 0, y: 0, z: ROBOTIQ_EPICK_TCP_Z_OFFSET / 2 },
  size: { x: 0.085, y: 0.085, z: ROBOTIQ_EPICK_TCP_Z_OFFSET },
} as const;
